module.exports = __webpack_public_path__ + "static/img/3.483d699.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/3.png
// module id = 1Gue
// module chunks = 0